function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 8,
  fill: "#67BD10"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.9997,
  cy: 24.0001,
  r: 16.32,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1876 24.2929C16.7971 23.9024 16.1639 23.9024 15.7734 24.2929C15.3828 24.6834 15.3828 25.3166 15.7734 25.7071L20.7734 30.7071C21.1639 31.0976 21.7971 31.0976 22.1876 30.7071L33.1876 19.7071C33.5781 19.3166 33.5781 18.6834 33.1876 18.2929C32.7971 17.9024 32.1639 17.9024 31.7734 18.2929L21.4805 28.5858L17.1876 24.2929Z",
  fill: "#67BD10"
});

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.55c54bbf.svg";
export { ForwardRef as ReactComponent };